import { render } from "./AddCourse.vue?vue&type=template&id=5085b2d0&ts=true"
import script from "./AddCourse.vue?vue&type=script&lang=ts"
export * from "./AddCourse.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__